import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { DPFormField } from 'src/app/core/models/DPFormField';
import { KeyValue } from 'src/app/core/models/KeyValue';

/**
 * Radio select component.
 * 
 * If emitKeyOnly is true,
 * the value is just key of selected option. 
 *
 * If emitKeyOnly is false,
 * the value is a JSON string of following object:
 *  { "selected option key": "selected option value" }
 */
@Component({
  selector: 'app-radio-group',
  standalone: true,
  imports: [NgClass, ReactiveFormsModule],
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
})
export class RadioGroupComponent implements OnInit {
  @Input() field: DPFormField;
  @Input() control: UntypedFormControl;
  @Input() disabled: boolean;
  @Input() emitKeyOnly: boolean = false;

  options: KeyValue[] = [];

  constructor() {}

  ngOnInit(): void {
    this.options = (this.field.options || []).map((opt) => ({
      key: this.emitKeyOnly
        ? opt.key
        : JSON.stringify({ [opt.key]: opt.value }),
      value: opt.value,
    }));
  }
}
